import { BaseModel, PaginationDataModel, convertToArrayModels, convertToModel, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import type { PaginationData } from '~/shared/interfaces'
import Employer from './Employer'

export default class EmployerListResult extends BaseModel {
  static override constructorName = 'EmployerListResult'

  items: Employer[] = []
  pagination: PaginationData = new PaginationDataModel()

  constructor(data?: unknown) {
    super(data)
    if (!isUnknownObject(data)) return

    this.items = convertToArrayModels(data.data, Employer)

    this.pagination = convertToModel(data.meta, PaginationDataModel, this.pagination)
  }

  get isEmpty(): boolean {
    return this.items.length === 0
  }
}

registerModel(EmployerListResult)
